import { render, staticRenderFns } from "./StudentRegisterExam.vue?vue&type=template&id=2648a373&scoped=true&"
import script from "./StudentRegisterExam.vue?vue&type=script&lang=js&"
export * from "./StudentRegisterExam.vue?vue&type=script&lang=js&"
import style0 from "./StudentRegisterExam.vue?vue&type=style&index=0&id=2648a373&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2648a373",
  null
  
)

export default component.exports